module.exports = __webpack_public_path__ + "img/zhuanpan.54274586.png";